<div class="stripe-connect-dialog">
  <div class="header-row">
    <p class="dialog-title">{{ 'Finish setting up Stripe' | translate }}</p>
    <button class="close-icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>{{ 'Loading...' | translate }}</p>
  </div>

  <div class="error-state" *ngIf="error">
    <p>{{ error | translate }}</p>
  </div>

  <!-- Stripe's embedded account-onboarding component is appended here imperatively
       (see mountOnboarding() in the .ts) — it's a native custom element, not
       something Angular's template binding renders. -->
  <div #onboardingContainer class="onboarding-container" [class.hidden]="loading || error"></div>
</div>
